import React from "react";
import { Modal } from "antd";

import CustomButton from "../customButton";

import "./styles.scss";

const ConfirmPopup = (props) => {
  const {
    isVisible,
    titleMessage,
    handleCancel,
    handleDelete,
    message,
    submitButtonText,
    cancelButtonText,
    isDelete,
  } = props;
  return (
    <Modal
      data-testid="confirm-popup-wrapper"
      className="confirm-modal"
      title={titleMessage}
      mask={false}
      visible={isVisible}
      centered
      footer={[
        <CustomButton
          className={`cancel-button ${isDelete && "danger-button"}`}
          onClick={handleCancel}
          title={cancelButtonText}
          key="cancel"
        />,
        <CustomButton
          className={isDelete && "danger-button"}
          htmlType="submit"
          type="primary"
          onClick={handleDelete}
          title={submitButtonText}
          key="submit"
        />,
      ]}
    >
      <p className="archive-text">{message}</p>
    </Modal>
  );
};
export default ConfirmPopup;
